<template>
    <div class="calendar-picker">
        <v-menu offset-y left :close-on-content-click="false" min-width="auto" ref="menu" v-model="date.menu">
        <template v-slot:activator="{ on, attrs }">
                <v-text-field :color="setCalendar == 0 ? 'primary' : 'gray'" elevation="0" outlined dense
                v-model="dateRangeText" readonly v-bind="attrs" v-on="on" hide-details
                :style="$vuetify.breakpoint.mobile ? '' : 'width: 240px'" append-icon="mdi-calendar"></v-text-field>
            </template>
            <div style="background: #fff">
                <div class="d-flex" style="position: relative">
                    <v-date-picker class="--custom-picker" no-title :prev-icon="null" :next-icon="null"
                    v-model="newDates" :pickerDate="months.first" range></v-date-picker>
                    <v-date-picker class="--custom-picker" no-title :prev-icon="null" :next-icon="null"
                    v-model="newDates" :pickerDate="months.last" range>
                    <v-spacer></v-spacer>
                    
                    <v-btn color="primary" elevation="0" @click="applyDate()">
                        {{ $t("common.ok") }}
                    </v-btn>
                </v-date-picker>
                <v-btn style="position: absolute; top: 5px; left: 5px;" icon
                @click="prevCalendar()"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn style="position: absolute; top: 5px; right: 5px;" icon
                @click="nextCalendar()"><v-icon>mdi-chevron-right</v-icon></v-btn>
            </div>
        </div>
    </v-menu>
</div>
</template>
<script>
import moment from 'moment'
export default {
    name: "CalendarPicker",
    data: () => ({
        newDates: [],
        months: {
            first: moment().subtract(1, 'month').format('YYYY-MM'),
            last: moment().format('YYYY-MM')
        },
        setCalendar: -1,
        date: {
                menu: false,
                dates: [
                    moment().subtract(1, "month").format("YYYY-MM-DD"),
                    moment().format("YYYY-MM-DD"),
                ],
            },
    }),
    props: {
        snap: {
            type: Array
        }
    },
    mounted(){
        this.date.dates = JSON.parse(JSON.stringify(this.snap))
    },
    computed: {
        dateRangeText() {
            let datesSelected = this.date.dates;
            let dates = [];
            if (datesSelected.length) {
                dates.push(moment(datesSelected[0]).format("l"));
                if (datesSelected.length > 1)
                    dates.push(moment(datesSelected[1]).format("l"));
            }

            return dates.join(" ➞ ");

        },
    },
    watch: {
        "date.dates": {
            deep: true,
            handler() {
                this.$emit('callback', true);
            }
        },
        "date.menu": {
            handler(val) {
                if (val) {
                    setTimeout(() => {
                        this.newDates = JSON.parse(JSON.stringify(this.date.dates));
                    }, 100);
                }
            }
        },
    },
    methods: {
        applyDate(fixedDays = 0) {
            this.setCalendar = fixedDays
            if (fixedDays) {
                const start = moment().format('YYYY-MM-DD');
                // console.log('start', start)
                this.newDates[0] = moment(`${start} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').subtract(fixedDays - 1, 'days').format('YYYY-MM-DD');
                this.newDates[1] = moment().format('YYYY-MM-DD');
            }
            const dates = JSON.parse(JSON.stringify(this.newDates));
            this.date.dates = moment(dates[0]).isBefore(dates[1]) ? [dates[0], dates[1]] : [dates[1], dates[0]];
            this.$emit('update-calendar', this.date.dates)
            this.date.menu = false;
        },
        prevCalendar() {
            this.months.first = moment(this.months.first, 'YYYY-MM').subtract(1, 'months').format('YYYY-MM')
            this.months.last = moment(this.months.last, 'YYYY-MM').subtract(1, 'months').format('YYYY-MM')
        },
        nextCalendar() {
            this.months.first = moment(this.months.first, 'YYYY-MM').add(1, 'months').format('YYYY-MM')
            this.months.last = moment(this.months.last, 'YYYY-MM').add(1, 'months').format('YYYY-MM')
        },
    }
}
</script>
<style lang="scss">
.--custom-picker {
    .v-date-picker-table {
        table {
            border-collapse: collapse;
        }
        td {
            width: 38px;
            margin-bottom: 1px;
            height: 42px;
        }
        .v-btn {
            width: 38px;
            height: 38px;
        }

        .v-btn--active {
            border-radius: 0;

            &.v-date-picker--first-in-range {
                border-top-left-radius: 19px;
                border-bottom-left-radius: 19px;
            }

            &.v-date-picker--last-in-range {
                border-top-right-radius: 19px;
                border-bottom-right-radius: 19px;
            }

        }
    }

    .v-date-picker-header {
        .v-btn--icon {
            display: none;
        }
    }
}
</style>